import PropTypes from 'prop-types';

import styles from './index.styl';

import MarkdownWrapper from 'core/components/MarkdownWrapper';
import Rate from './Rate';

export default function Verdict(block, parentProps) {
  const {
    attributes: {
      text,
      score,
    },
  } = block;

  const {
    theme: {
      controls: {
        vikontVerdict: {
          title: {
            font: titleFont,
          },
          text: {
            font: textFont,
          },
          block: {
            background,
          },
        },
      },
    },
  } = parentProps;

  return (
    <div className={styles.verdictWrapper}>
      <style jsx>{`
        .${styles.verdictTitle}
          font ${titleFont}

        .${styles.text}
          font ${textFont}

        .${styles.verdictWrapper}
          background-color ${background}
      `}</style>

      <p className={styles.verdictTitle}>Вердикт</p>
      <Rate value={score} />
      <div className={styles.text}>
        <MarkdownWrapper>
          {text}
        </MarkdownWrapper>
      </div>
    </div>
  );
}

Verdict.propTypes = {
  block: PropTypes.object,
  parentProps: PropTypes.object,
  ctx: PropTypes.object,
};
